<template>
  <div class="chart-wrapper">
    <ul class="step-list">
      <li v-for="(step, index) in route" :key="index" class="step" :class="step.state">
        <font-awesome-icon v-if="statusIcon(step.state)" :icon="statusIcon(step.state)" />
        <span v-if="step.code === 13 || step.code === 15" v-b-tooltip.hover title="ขั้นตอนนี้เป็นการพิจารณาอนุมัติผ่านอีเมลเท่านั้น">
          {{ step.name }}
          <font-awesome-icon
            icon="question-circle"
            class="mr-0 ml-1"
          />
        </span>
        <span v-else>{{ step.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    route: { type: Array, required: true },
    status: { type: String, required: true },
    group: { type: Object, required: true },
    project: { type: Object, required: true }
  },
  methods: {
    statusIcon (status) {
      switch (status) {
        case 'pending':
          return ['far', 'clock']
        case 'passed':
          return 'check-circle'
        case 'rejected':
          return 'exclamation-circle'
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-wrapper {
  width: 100%;
  overflow: hidden;
}

.step-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

  li {
    display: inline-block;
    flex: 1 1 auto;
    text-align: center;
    background-color: $gray-200;
    padding: 5px;
    position: relative;
    font-size: 0.8rem;
    white-space: nowrap;

    &:not(:first-child) {
      padding-left: 25px;
    }

    &:first-child,
    &:last-child {
      border-radius: 5px;
    }

    &.passed {
      background-color: desaturate($success, 10%);
      color: #fff;

      &:after {
        border-left-color: desaturate($success, 10%);
      }
    }

    &.pending {
      background-color: desaturate($warning, 10%);
      color: #fff;

      &:after {
        border-left-color: desaturate($warning, 10%);
      }
    }

    &.rejected {
      background-color: desaturate($danger, 10%);
      color: #fff;

      &:after {
        border-left-color: desaturate($danger, 10%);
      }
    }

    &:last-child {
      &:after,
      &:before {
        display: none;
      }
    }

    &:after {
      content: "";
      display: block;
      right: -32px;
      border: solid transparent;
      border-left-color: $gray-200;
      border-width: 17.5px;
      position: absolute;
      top: 0;
      z-index: 3;
    }

    &:before {
      content: "";
      display: block;
      right: -39px;
      border: solid transparent;
      border-left-color: #fafafa;
      border-width: 20.5px;
      position: absolute;
      top: -3px;
      z-index: 2;
    }
  }
}
</style>
